mutation Contact($email: String!, $message: String!) {
  contact(email: $email, message: $message) {
    ok
    errors
  }
}
